export const CURRENCIES = [
  { symbol: '$', code: 'USD', label: 'US Dollar' },
  { symbol: '\u20ac', code: 'EUR', label: 'Euro' },
  { symbol: '\u00a3', code: 'GBP', label: 'British Pound' },
  { symbol: '\u20b9', code: 'INR', label: 'Indian Rupee' },
  { symbol: '\u00a5', code: 'JPY', label: 'Japanese Yen' },
  { symbol: 'A$', code: 'AUD', label: 'Australian Dollar' },
  { symbol: 'C$', code: 'CAD', label: 'Canadian Dollar' },
  { symbol: 'Fr', code: 'CHF', label: 'Swiss Franc' },
  { symbol: 'R$', code: 'BRL', label: 'Brazilian Real' },
  { symbol: '\u20a9', code: 'KRW', label: 'Korean Won' },
  { symbol: 'S$', code: 'SGD', label: 'Singapore Dollar' },
  { symbol: 'NZ$', code: 'NZD', label: 'New Zealand Dollar' },
  { symbol: 'HK$', code: 'HKD', label: 'Hong Kong Dollar' },
  { symbol: 'AED', code: 'AED', label: 'UAE Dirham' },
  { symbol: 'SAR', code: 'SAR', label: 'Saudi Riyal' },
  { symbol: 'ZAR', code: 'ZAR', label: 'South African Rand' },
];

const SYMBOL_ALIASES = new Map([
  ['US$', 'USD'],
  ['CA$', 'CAD'],
  ['AU$', 'AUD'],
  ['A$', 'AUD'],
  ['C$', 'CAD'],
  ['NZ$', 'NZD'],
  ['HK$', 'HKD'],
]);

export const DEFAULT_CURRENCY = CURRENCIES[0];

export function getCurrencyByCode(code) {
  const normalized = String(code || '').trim().toUpperCase();
  return CURRENCIES.find((currency) => currency.code === normalized) || null;
}

export function getCurrencyBySymbol(symbol) {
  const normalized = String(symbol || '').trim();
  const aliasCode = SYMBOL_ALIASES.get(normalized.toUpperCase());
  if (aliasCode) return getCurrencyByCode(aliasCode);
  return CURRENCIES.find((currency) => currency.symbol === normalized) || null;
}

export function normalizeCurrency(value, fallback = DEFAULT_CURRENCY) {
  return getCurrencyByCode(value) || getCurrencyBySymbol(value) || fallback;
}

export function splitPriceCurrency(value, fallback = DEFAULT_CURRENCY) {
  const raw = String(value || '').trim();
  const currency = CURRENCIES.find((option) => {
    const escaped = option.symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(^|\\s)${escaped}\\s*\\d|\\d\\s*${escaped}($|\\s)`, 'i').test(raw) ||
      new RegExp(`(^|\\s)${option.code}\\s*\\d|\\d\\s*${option.code}($|\\s)`, 'i').test(raw);
  }) || fallback;

  return {
    currency,
    price: raw.replace(/[^\d.,]/g, ''),
  };
}

export function formatMoney(price, currencyValue, fallback = DEFAULT_CURRENCY) {
  if (!price) return '';
  const currency = normalizeCurrency(currencyValue, fallback);
  return `${currency.symbol}${price}`;
}
